module.exports = __webpack_public_path__ + "img/LOGO.82b829ea.svg";